import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'role', label: 'Role / relationship', type: 'text' },
    { key: 'quote', label: 'Quote', type: 'textarea' },
    { key: 'photo_url', label: 'Photo', type: 'upload-image', prefix: 'testimonials' },
    { key: 'location', label: 'Location', type: 'text' },
    { key: 'rating', label: 'Rating (1-5)', type: 'number' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'name', label: 'Name', primary: true },
    { key: 'role', label: 'Role' },
    { key: 'location', label: 'Location' },
    { key: 'rating', label: 'Rating' },
];

const defaultItem = {
    name: '',
    role: '',
    quote: '',
    photo_url: '',
    location: '',
    rating: 5,
    order: 99,
};

export default function AdminTestimonialsPage() {
    return (
        <CrudManager
            resource="testimonials"
            title="Testimonials"
            description="Success stories and voice-of-community."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['name', 'role']}
        />
    );
}
